import {
  AppConfigurationClient,
  GetConfigurationSettingResponse,
  SetConfigurationSettingParam
} from '@azure/app-configuration'
import isEmpty from 'lodash/isEmpty'

class AzureConfigService {
  private readonly azureClient: AppConfigurationClient

  constructor() {
    this.azureClient = new AppConfigurationClient(import.meta.env.VITE_AZURE_CONFIG_URL)
  }

  async getAzureSetting(settings: SetConfigurationSettingParam): Promise<GetConfigurationSettingResponse> {
    try {
      const azureConfig = await this.azureClient.getConfigurationSetting({ ...settings })
      if (isEmpty(azureConfig) || isEmpty(azureConfig.value)) {
        throw new Error('Bad Azure Config')
      }

      return azureConfig
    } catch (error) {
      console.error(error)
      throw new Error(error as string)
    }
  }
}

export default AzureConfigService
